import { useEffect, useState } from 'react';

interface ComputerUseElapsedInput {
  running: boolean;
  firstObservedAt: number | undefined;
}

/** Own one clock per task card. Trace trimming must not move its start time. */
export const useComputerUseElapsed = ({
  running,
  firstObservedAt,
}: ComputerUseElapsedInput): number | null => {
  const [startedAt, setStartedAt] = useState<number | null>(null);
  const [elapsedSeconds, setElapsedSeconds] = useState<number | null>(null);

  useEffect(() => {
    // A settled history card has no measured duration on this client.
    if (running && firstObservedAt !== undefined) {
      setStartedAt((current) => current ?? firstObservedAt);
    }
  }, [running, firstObservedAt]);

  useEffect(() => {
    if (startedAt === null) return;

    const tick = () => {
      setElapsedSeconds(Math.max(0, Math.floor((Date.now() - startedAt) / 1000)));
    };

    // Read the clock at completion too, even if interval callbacks were delayed.
    tick();
    if (!running) return;
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [running, startedAt]);

  return elapsedSeconds;
};
